import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues, formatSingleTime } from '@/pages/dashboard/utils/utils';
import { getDefaultUtcDateValue } from "@/pages/dashboard/utils/dateUtils";
import KeyMetrics from './KeyMetrics';
import './index.scss';
import { getApiData } from '@/pages/dashboard/services/common';

export default function MobileKeyMetricsCo(props: any) {
  const { style, className, type, config, ...resetProps } = props || {};
  const { api, trendApi, mainMetricsList = [], metricsList = [], isDark = false, isMoblie = false, haveJump = false, height = 340, isChangeHeight = 322 } = config || {};

  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    metricsList,
    mainMetricsList,
    isDark,
    isMoblie,
    haveJump,
    height,
    isChangeHeight,
  }), [gameCode, metricsList, mainMetricsList, isDark, isMoblie, haveJump, height, isChangeHeight]);

  const apiRequest = ({ timeType, rangeTime: [start, end], ...params }: any) => {
    const metric = getApiData(api, { ...params, start_time: start, end_time: end }).catch(() => { return { card_list: [] } });
    const trend = getApiData(trendApi, { ...params, metrics: metricsList }).catch(() => { return { Nodes: [] } });
    const nowKeyMap: any = {
      Day: 'to_date',
      Week: 'to_week',
      Month: 'this_year',
    };
    const lastKeyMap: any = {
      Day: 'last_week',
      Week: 'last_month',
      Month: 'last_year',
    };
    const nowKey = nowKeyMap?.[timeType] || nowKeyMap['Day'];
    const lastKey = lastKeyMap?.[timeType] || lastKeyMap['Day'];
    return Promise.all([metric, trend]).then(([res1, res2]) => {
      const list = res2?.Nodes || [];
      const trendList = list?.map((item: any) => {
        const { date, ...rest } = item || {};
        const metrics: any = {};
        Object.keys(rest)?.map((key: any) => {
          const keyObj = { value: rest?.[key]?.[nowKey] || '', last_value: rest?.[key]?.[lastKey] || '' };
          metrics[key] = keyObj;
        });
        return { date, metrics };
      });

      return {
        card_list: res1?.card_list || [],
        trend_list: trendList
      };
    }).catch((e) => {
      console.log(e);
    });
  };

  return (
    <div className={className} style={style}>
      <Service
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        api={apiRequest}
        data={data}
        dataKey={'keyMetricsData'}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const { timeType, diff, rangeTime, ...filters } = filterVal || {};
          const defaultTimeRange = getDefaultUtcDateValue(timeType, rangeTime);
          const rangeTimeArr = diff ? defaultTimeRange : formatSingleTime(rangeTime, timeType);
          const [start, end] = rangeTimeArr;
          const params = {
            game_code: gameCode,
            // period: PERIODTIMEOBJ?.[timeType],
            filters: formatFilterValues(filters),
            start_time: start,
            end_time: end,
            timeType,
            rangeTime,
          };
          return params;
        }}
        trackData={['gameCode', 'metricsList', 'mainMetricsList', 'isDark']}>
        <KeyMetrics {...resetProps}></KeyMetrics>
      </Service>
    </div>
  );
};
